import ReactPixel from 'react-facebook-pixel';
import './styles/PriceHero.css';

function PriceHero() {

    const handleClickBuyBtn = () => {
            ReactPixel.track('InitiateCheckout', {
                action: 'Clique COMPRAR AGORA',
                origem: 'Seção Preço do Produto',
            });
            ReactPixel.trackCustom('Lead', {
                action: 'Clique COMPRAR AGORA',
                origem: 'Seção Preço do Produto',
            });
            window.open('https://pay.hotmart.com/K104003704P?off=0tb745dd&checkoutMode=10', '_blank');
    };

    return (
        <div className="PriceContainer">
            <h3>Não perca essa oportunidade!</h3>
            <div className="top-price">
                <p><span style={{ color: '#888', textDecorationLine: 'line-through', fontSize: '40px'}}>R$297,00</span></p>
            </div>
            <div className="bottom-price">
                <p>por apenas: <br/><span style={{ color: '#FF0000', fontWeight: 'bold'}}>R$47,00</span></p>
            </div>
            <button className="buy-btn" onClick={handleClickBuyBtn} aria-label="Clique para comprar o curso agora">COMPRAR AGORA</button>
        </div>
    )
}

export default PriceHero;